import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import TrendingSection from "@/pages/home/components/TrendingSection";
import CategorySection from "@/pages/home/components/CategorySection";
import FeatureGrid from "@/pages/home/components/FeatureGrid";
import TopicSection from "@/pages/home/components/TopicSection";
import LatestSection from "@/pages/home/components/LatestSection";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBand from "@/pages/home/components/CtaBand";
import { articles } from "@/mocks/articles";
import { getFeaturedArticle, getTrendingArticles } from "@/utils/content";

const siteJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "黑料八卦",
      alternateName: "黑料八卦官网",
      url: "https://glmrz.cn/",
      description:
        "黑料八卦官网收录综艺、影视、节目、剧组相关幕后八卦与拍摄现场花絮，补全镜头之外的剧情。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://glmrz.cn/category/backstage?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "黑料八卦",
      url: "https://glmrz.cn/",
      description: "专注综艺、影视与剧组幕后内容的娱乐资讯站点。",
      email: "hello@heiliao-bagua.example",
    },
  ],
};

export default function Home() {
  const featured = getFeaturedArticle();
  const picks = articles.filter((item) => item.id !== featured.id).slice(0, 4);
  const trending = getTrendingArticles(6);
  const latest = articles.slice(0, 4);
  const gridArticles = articles.filter((item) => !item.featured).slice(0, 4);
  const listArticles = articles.slice(4, 9);

  useEffect(() => {
    document.title = "黑料八卦官网 - 综艺影视剧组幕后八卦与拍摄现场花絮";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "黑料八卦官网收录综艺、影视、节目、剧组相关幕后八卦。拍摄现场发生了什么、剪辑台剪掉了什么，这里给你补全镜头之外的剧情。",
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteJsonLd) }}
      />
      <SiteHeader />
      <main>
        <h1 className="sr-only">黑料八卦官网 - 综艺影视剧组幕后八卦与拍摄现场花絮</h1>
        <HeroSection featured={featured} picks={picks} />
        <TrendingSection trending={trending} latest={latest} />
        <CategorySection />
        <FeatureGrid articles={gridArticles} />
        <TopicSection />
        <LatestSection articles={listArticles} />
        <CtaBand />
        <TestimonialSection />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}